<template>
  <div class="animated fadeIn">
    <b-card border-variant="primary" id="list">
      <template slot="header">
        <i class='fa fa-align-justify'></i> Group(Customers) List
      </template>
      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Join_at
                <b-button size="sm" variant="info" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.joined_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.joined_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_group">Service</label>
              <br>
              <v-select v-model="so.opt['service']" label="name" :options="codes.service_name"></v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" v-if="partner">
            <b-form-group>
              <label for="opt_groupname">Name</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_groupname" v-model="so.opt['groupname']"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_group_email">E-Mail</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_group_email" v-model="so.opt['email']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- <b-row>
          <b-col md="4">
            <b-form-group>
              <label for="opt_country">Country</label>
              <v-select v-model="so.opt['country']" :options="codes.country"></v-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_timezone">Timezone</label>
              <v-select v-model="so.opt['timezone']" :options="codes.timezone"></v-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_language">Language</label>
              <v-select v-model="so.opt['language']" :options="codes.language"></v-select>
            </b-form-group>
          </b-col>
        </b-row> -->
        <b-row>
          <b-col md="12">
            <label for="ph_search_opt_type">Match Type</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:Match all</b-form-radio>
                <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group class="float-right">
          <b-button size="sm" variant="success" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->
      <hr>
      <b-row>
        <b-col sm="2" v-if="view_detail !== false">
          <b-badge variant="primary">
            TOTAL : {{model.enable + model.disable || 0}}
          </b-badge>
          <br>
          <b-badge variant="success">
            USE : {{model.enable || 0}}
          </b-badge>
          <br>
          <b-badge variant="warning">
            Deleted : {{model.disable || 0}}
          </b-badge>
        </b-col>
        <b-col :sm="view_detail !== false ? 10 : 12" class="md-10">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :disabled="so.adv" :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='service';so.skt='Service'; so.sv = '';">Service</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='groupname';so.skt='Name'; so.sv = '';">Name</b-dropdown-item>
              </b-dropdown>

              <v-select :disabled="so.adv" label="name" v-if="so.sk == 'service'" @change="refresh" v-model="so.sv" :options="codes.service"></v-select>
              <!-- <select  v-model="so.sv"  :option="codes.service">
                <option value="true">Verified</option>
                <option value="false">Not Verified</option>
              </select> -->
            </b-input-group-prepend>
            <b-form-input v-if="so.sk != 'service'" :disabled="so.adv" v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
          <br>
          <b-input-group size="sm">
            <select v-model="so.perPage" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Show count : Default 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>

            <select v-if="auto_refresh" v-model="sync.interval" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Please select interval : Default 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 min)</option>
            </select>
            <span v-if="auto_refresh" class="float-right" style="margin-right:15px">
              <i :class="`fa fa-refresh ${th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
              <b-btn @click="pause" size="sm" variant="warning">
                {{!sync.stop ? "Auto refresh"  : "Pause"}}
              </b-btn>
            </span>
            <div>
              <b-button v-if="enable_new !== false && auth.profile.permissions != 'billing'" size="sm" variant="success" @click="addWithPartner"> New Registration </b-button>
            </div>
            <b-checkbox @change="refresh" class="ml-3 mt-1" v-model="hide_del">Hide deleted</b-checkbox>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" foot-clone ref="_list"
        show-empty empty-text="not found"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="joined_at" slot-scope="row">{{row.item.joined_at | sdate }}</template>
        <template slot="groupname" slot-scope="row">
          <span v-if="row.item.language">[{{row.item.language.toUpperCase()}}]</span>
          [User : {{row.item.count || 0}}] {{row.item.groupname }}
        </template>
        <template slot="country" slot-scope="row">{{row.item.country }}</template>
        <template slot="credit" slot-scope="row">
          {{row.item.credit | dollar }}
          <b-button v-if="auth.profile.permissions != 'manager'" size="sm" variant="outline-info" @click="modal_credit = true; credit = row.item">+ / -</b-button>
        </template>
        <template slot="service" slot-scope="row">
          <b-badge  :variant="row.item.service === 'Basic' ? 'info' : 'success'"> {{row.item.service}} </b-badge>
        </template>
        <!-- <template slot="is_verified" slot-scope="row">
          <c-switch color="info" label size="sm" v-model="row.item.is_verified" :disabled="true" />
        </template> -->
        <template slot="count" slot-scope="row">{{row.item.count | number }}</template>
        <template slot="func" slot-scope="row">
          <b-btn v-if="auth.profile.permissions != 'billing'" @click="detail(row.item)" size="sm" variant="outline-primary">
            {{(model && model.id == row.item.id ? 'Selected' : (view_detail != false ? 'Detail' : 'Select') )}}
          </b-btn>
          <b-btn v-if="auth.profile.permissions != 'manager'" @click="billing(row.item)" size="sm" variant="outline-success">
            <b>Billing</b>
          </b-btn>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"  />
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="billing_pop" size="xl" title="Billing Info"  class="modal-warning" @ok="billing_pop = false" ok-variant="success" no-close-on-backdrop ok-only>
      <b-table hover striped small responsive="sm" foot-clone ref="_billing" show-empty empty-text="There is no payment history!" :items="this.invoices" :fields="pay">
        <!-- <template slot="id" slot-scope="row">{{startRow - row.index}}</template> -->
        <template slot="apply_at" slot-scope="row">{{row.item.apply_date.substring(0, 6)}}</template>
        <template slot="servicename" slot-scope="row">{{row.item.group.service}} / {{row.item.service_unit}} ea.</template>
        <template slot="base_price" slot-scope="row">${{row.item.base_price}}</template>
        <template slot="discount_price" slot-scope="row">{{row.item.discount_price | number}} </template>
        <template slot="total_price" slot-scope="row">${{row.item.total_price}} </template>
        <template slot="is_paid" slot-scope="row">{{row.item.is_paid ? 'Payment completed' : 'unpaid'}}</template>
        <!-- <template slot="next_date" slot-scope="row">{{row.item.protocol}}</template> -->
        <template slot="func" slot-scope="row">
          <b-btn v-if="row.item.is_paid == false" @click="prepayment(row.item)" size="sm" variant="outline-primary">Prepayment</b-btn>
        </template>
      </b-table>
      <b-modal v-model="prepayment1" @ok="test(mm)">
        Would you like to pay in advance?
        <!-- {{mm}} -->
        <b-input v-if="mm" v-model="mm.total_price"></b-input>
      </b-modal>
    </b-modal>
    <b-modal v-model="modal_credit" size="lg" @ok="Credit_Toss()" title="Customers Credit">
      <b-row>
        <b-col lg="12" xl="12">
          <b-card border-variant="primary">
            <b-row>
              <b-col md="12">
                <b-form-group>
                  <label for="ph_name">Credit Deposit or Withdraw</label>
                  <b-input-group size="sm" prepend="$">
                    <b-form-input v-model="amount" type="number"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group>
                  <label for="ph_address">Credit Info(*)</label>
                  <!-- <b-form-input md=12 type="text" id="ph_address" v-model="model.address" :disabled="lock"></b-form-input> -->
                  <b-textarea v-model="amount_log"></b-textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <b-button-group>
              <b-button size="sm" variant="info" v-on:click="amount += 10">+ 10</b-button>
              <b-button size="sm" variant="info" v-on:click="amount += 50">+ 50</b-button>
              <b-button size="sm" variant="info" v-on:click="amount += 100">+ 100</b-button>
            </b-button-group>

            <b-button-group>
              <b-button size="sm" variant="warning" v-on:click="amount -= 10">- 10</b-button>
              <b-button size="sm" variant="warning" v-on:click="amount -= 50">- 50</b-button>
              <b-button size="sm" variant="warning" v-on:click="amount -= 100">- 100</b-button>
            </b-button-group>
          </b-card>
        </b-col>
      </b-row>
    </b-modal>
    </div>
</template>

<script>
import { Api, auth } from '@/service';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import codes from '@/codes';
import { Switch as cSwitch } from '@coreui/vue';
import moment from 'moment-timezone';
import vSelect from 'vue-select';

let default_opt = function() {
  return {
    perPage: 15,
    currentPage: 1, totalRows: 0,
    sk: 'groupname', sv: '', skt: 'Name', opt : {}, adv : false
  }
}

export default {
  components: { DatePicker, cSwitch, vSelect },
  name : "groupList",
  props : ["auto_refresh", "enable_new", "view_detail", "partner", "addPartner"],
  data: () => ({
    hide_del : true,
    auth,
    amount_log : '',
    deposit : false,
    credit: undefined,
    modal_credit : false,
    amount : 0,
    prepayment1 : false,
    popup : {},
    billing_pop : false,
    custom,
    mm : undefined,
    invoices : [],
    temp : undefined,
    codes,
    so : default_opt(),
    model : { total : 0, enable : 0, disable : 0 },
    sync : { interval : 15, stop : false, th : undefined },
  }),
  computed: {
    pay() {
      return [
        { key: 'apply_at', label: 'Month', sortable: true, thStyle: 'width: 5%' },
        { key: 'servicename', label: 'Service(Price x Usage)', sortable: true, thStyle: 'width: 10%' },
        { key: 'base_price', label: 'Usage(ea)', sortable: true, thStyle: 'width: 10%' },
        { key: 'discount_price', label: 'Discount Amount', sortable: true, thStyle: 'width: 10%' },
        { key: 'total_price', label: 'Total Price', sortable: true, thStyle: 'width: 10%' },
        { key: 'is_paid', label: 'Payment status', sortable: true, thStyle: 'width: 10%' },
        // { key: 'func', label: 'status', sortable: false, thStyle: 'width: 5%'  },
      ]
    },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      let f = []
      f.push({ key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' })
      f.push({ key: 'joined_at', label: 'Join_at', sortable: false }),
      f.push({ key: 'groupname', label: 'Name', sortable: false }),
      f.push({ key: 'service', label: 'Service', sortable: false })
      // f.push({ key: 'is_verified', label: 'Verified', sortable: false })

      if (this.view_detail !== false) {
        f.push({ key: 'groupname', label: 'Name', sortable: false });
        f.push({ key: 'email', label: 'E-Mail', sortable: false });
      }
      f.push({ key: 'credit', label: 'Credit', sortable: false }),
      f.push({ key: 'func', label: 'Action', sortable: false, thStyle: 'width: 10%'  })
      return f;
    }
  },
  methods: {
    async Credit_Toss(){
      try {
        console.info(this.amount)
        let a = this.amount
        // Partner -> Group Credit Toss Process
        if(a > 0){
          await Api.Partner_Call('group', 'update.credit.plus', { group_id : this.credit.id, amount : this.amount, reason : this.amount_log  })
        }
        if(a < 0){
          await Api.Partner_Call('group', 'update.credit.minus', { group_id : this.credit.id, amount : this.amount, reason : this.amount_log  })
        }
        this.$toastr.i('Success!');
        // this.refresh();
        if (this.$refs._list) { this.$refs._list.refresh(); }

      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); }
    },
    async test(m){
      await Api.Partner_Call('group.invoice', 'pay.credit', { id : m.id, amount : m.total_price })

      this.billing(this.temp)
    },
    async prepayment(m){
      this.prepayment1 = true;
      this.mm = m;
    },
    async billing(m){
      // target : group.invoice cmd : list
      // group_id 만 주면됨.
      console.info(m)
      this.temp = m;
      let a = {
        target : 'group.invoice', cmd : 'list',
        body : { sort : [{ name : "id", op : "desc" }], or : [], and : [{ name : 'group_id', value : m.id, op : '=' }, { name : 'group.partner_id', value : m.partner_id, op : '=' }] }
      }

      let b = await Api.Partner(a)
      // console.info(this.popup)
      this.invoices = b.body
      this.billing_pop = true;
    },
    addWithPartner() {
      if(this.addPartner === true) {
        this.$router.push({ name: 'group', params: { id : this.$route.params.id, tag : "partner" } })
      } else {
        this.$router.push({ name: 'group', params: { id : 'add' } })
      }
    },
    set_sd(v, k = 'joined_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['joined_at_ed'] = moment();
        this.so.opt['service'] = "Basic";
        this.so.opt['match_type'] = 'and';
        this.so.opt['is_verified'] = 'true';

        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(k == 'permissions') {
        return { name : k, value : v, op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; }
      if(!this.sync.th && this.sync.stop) { this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() {
      this.$refs._billing ? this.$refs._billing.refresh() : ''
      this.$refs._list ? this.$refs._list.refresh() : ''
    },
    getRowCount () { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let and = []
      let so = {
        target : 'group', cmd : 'list',
        body : {
          sort : [{ name : "id", op : "desc" }],
          or : [],
          and : and
        },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }

      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' } ); }
      if(this.partner) { so.body.and.push({ name : "partner_id", Value : this.partner.id, op : "=" }) }
      if(this.hide_del) { so.body.and.push({ name : 'is_del', value : false, op : '=' }); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'is_verified':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'joined_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.warn("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 9), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'joined_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.warn("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 9), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return Api.Partner(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    summary() {
      let and = [];
      let id = undefined;
      if(this.partner) { id = this.partner.id; and.push({ name : 'partner_id', value : id, op : '='}) }
      Api.Partner({ target : 'group', cmd : 'summary', body : { and : and, or : [], sort : [] } })
        .then(rs => { this.model = Object.assign(this.model, { enable : rs.body.enable, disable : rs.body.disable }) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail(item) {
      if(this.view_detail == false) { this.$emit("select", item); }
      else {
        this.$router.push({ name : 'group', params : { id : item.id } });
      }
    },
    add: async function() {
      try {
        if(!(this.model.groupname || '').trim()) { return this.$toastr.e('Group Name is Require.'); }

        let rs = await Api.Partner_Call('group', this.model.id ? 'update' : 'insert', this.model);
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name); this.list();
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list()}
    },
  },
  created() { console.log('group.list.vue', 'created'); },
  destroyed() { console.log('group.list.vue', 'destroyed'); },
  mounted() { console.log('group.list.vue', 'mounted');
    if(this.view_detail !== false) { setTimeout(this.summary, 1000) }
  },
}
</script>
